import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/logout')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    if (auth.isAuthenticated) {
      await auth.logout();
    } else {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
});
